<template>
    <div>
        <el-row class="w-96" v-for="(item, index) in list" :key="index">
            <el-col :span="10" class="pr-2" v-for="input in fileds" :key="input.key">
                <el-input :readonly="readonly" @input="onInput" v-model="item[input.key]" v-bind="input"></el-input>
                <!-- <span class="text-gray-500" v-else>{{ item[input.key] }}</span> -->
            </el-col>
            <el-col :span="2" v-if="!readonly">
                <el-button @click="onDelete(index)" class="w-full text-red-600" size="small" type="text">删除</el-button>
            </el-col>
        </el-row>
        <template v-if="readonly && list.length === 0">
            <span class="text-gray-500">--</span>
        </template>
        <template v-if="!readonly">
            <el-button @click.stop="onAdd" size="small" type="text">添加</el-button>
            <el-button @click.stop="onBatchAdd" size="small" type="text">批量添加</el-button>
        </template>
        <el-dialog :close-on-click-modal="false" append-to-body title="批量添加" :visible.sync="visible" width="500px">
            <el-input type="textarea" :rows="6" placeholder="请输入内容" v-model="content">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" @click="onOk">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { cloneDeep } from 'lodash';
export default {
    props: {
        value: {
            type: Array|undefined,
            default: () => []
        },
        itemProps: {
            type: Object,
            default: () => { }
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            list: [],
            visible: false,
            content: ""
        }
    },
    watch: {
        value: {
            handler(val) {
                this.list = cloneDeep(val) || [];
            },
            deep: true
        }
    },
    computed: {
        fileds() {
            let keys = []
            Object.keys(this.itemProps).map((key) => {
                keys.push({ key: key, ...this.itemProps[key] });
            });
            return keys;
        }
    },
    methods: {
        onAdd() {
            let emptyItem = {};
            Object.keys(this.itemProps).map((key) => {
                emptyItem[key] = "";
            });
            this.list.push(emptyItem);
            this.$nextTick(() => {
                this.$emit('change', this.list);
            });
        },
        onDelete(index) {
            this.list.splice(index, 1);
            this.$nextTick(() => {
                this.$emit('change', this.list);
            });
        },
        onBatchAdd() {
            this.visible = true;
        },
        onInput() {
            this.$emit('change', this.list);
        },
        onOk() {
            try {
                const item = this.content.split('\n').filter((e) => !!e);
                const parsedItems = item.map((line) => {
                    const [code, name] = line.split(',');
                    return { code: code.trim(), name: name.trim() };
                });
                this.list.push(...parsedItems);
                this.visible = false;
                this.content = "";
                this.$nextTick(() => {
                    this.$emit('change', this.list);
                });
            } catch (error) {
                this.$message.error('请输入正确的格式');
            }
        }
    },
    created() {
        const v = this.value || [];
        this.list = cloneDeep(v);
    },
    model: {
        prop: 'value',
        event: 'change'
    }
}
</script>

<style lang="scss" scoped></style>